export default "__VITE_ASSET__158157e9__"